<script lang="ts">
  import { t } from '$lib/i18n';
  import { region, type Region } from '$lib/region';
  import { toaster } from '$lib/toaster';
  import { trimVariantId } from '$lib/utils/shopify/productsId';
  import { createMutation } from '@tanstack/svelte-query';
  import Input from '$components/ui/input.svelte';
  import Button from '$components/ui/button.svelte';
  import WishlistButton from './wishlist-button.svelte';

  let value = '';

  export let productId: string;
  export let variant: string;
  export let showWishlistButton: boolean | undefined = true;

  const mutation = createMutation<
    unknown,
    unknown,
    { email: string; region: Region; variant: string }
  >({
    mutationKey: ['notifyMe'],
    mutationFn: async (vars) => {
      const res = await fetch('/api/notify-me/', {
        method: 'POST',
        body: JSON.stringify(vars)
      });
      if (!res.ok) throw new Error('Error subscribing to notify you');
      return res.json();
    },
    onSuccess: () => {
      value = '';
      toaster({
        type: 'success',
        title: `${$t('pdp.out-of-stock.success.title')}`,
        description: `${$t('pdp.out-of-stock.success.description')}`
      });
    },
    onError: () => {
      toaster({
        type: 'error',
        title: `${$t('pdp.out-of-stock.error.title')}`,
        description: `${$t('pdp.out-of-stock.error.description')}`
      });
    }
  });
</script>

<form>
  <Input type="email" bind:value placeholder={$t('pdp.out-of-stock.placeholder')} class="mt-4" />
  <div class="flex mt-2 gap-2">
    <Button
      name="notify-me"
      disabled={!value}
      type="submit"
      loading={$mutation.isLoading}
      class="grow"
      size="sm"
      on:click={(e) => {
        e.preventDefault();
        $mutation.mutate({
          email: value,
          region: $region,
          variant: trimVariantId(variant)
        });
      }}
      >{$t('pdp.out-of-stock.notify')}
    </Button>

    {#if showWishlistButton}
      <div aria-hidden="true" on:click={(e) => e.preventDefault()}>
        <WishlistButton {productId} />
      </div>
    {/if}
  </div>
</form>
